import http from 'src/app/http';


const getAgreements = (params) => http.get('/agreements/content', { params });


const prepareAgreementsURLParams = (codes) => {
  const agreementsParams = new URLSearchParams();
  codes.forEach((code) => agreementsParams.append('codes', code));

  return agreementsParams;
};

export default { getAgreements, prepareAgreementsURLParams };
